export const emptyValueLabel = (value?: any): any => {
  if (value?.value === '' && value?.label === '') {
    return null;
  }
  return value;
};
